import Card from '@/components/Card';
import { Options } from '@/components/ui/CheckboxGroup';
import { ConditionalRender } from '@/components/ui/ConditionalRender';
import { ATTACHMENT_TYPES } from '@/consts';
import {
  CheckboxGroupDamageRightsAssignments,
  DAMAGE_RIGHTS_ASSIGNMENTS,
} from '@/features/v2/vehicle-damage/components/CheckboxGroupDamageRightsAssignments';
import { REPAIR_DOCUMENTS_PROVIDED_TO_IC } from '@/features/v2/vehicle-damage/components/CheckboxGroupRepairDocumentsProvided';
import AddDocuments, {
  DOCUMENTS_DAMAGE_AOB_LIST_NAME,
  DOCUMENTS_DAMAGE_RIGHTS_AUTHORIZATIONS_LIST_NAME,
  DOCUMENTS_DAMAGE_RIGHTS_POA_LIST_NAME,
} from '@/features/v2/vehicle-damage/components/documents/AddDocuments';
import {
  InputDocumentType,
  PROVIDED_TO_IC_INVOICES_LIST,
  PROVIDED_TO_IC_OTHER_DOCUMENTS_LIST,
  PROVIDED_TO_IC_RECEIPTS_LIST,
} from '@/features/v2/vehicle-damage/components/InputDocumentType';
import {
  DAMAGE_AOB_LIST_NAME,
  DAMAGE_RIGHTS_AUTHORIZATIONS_LIST_NAME,
  DAMAGE_RIGHTS_POA_LIST_NAME,
  SelectAssignmentOfDamageRightsDocumentsSubject,
} from '@/features/v2/vehicle-damage/components/SelectAssignmentOfDamageRightsDocumentsSubject';

import { useLingui } from '@lingui/react';

const SurveyFour = () => {
  const { i18n } = useLingui();

  return (
    <>
      <ConditionalRender
        when={(val) =>
          val.repair_documents_provided_to_ic
            ?.map((item: Options) => item.value)
            ?.includes(REPAIR_DOCUMENTS_PROVIDED_TO_IC.INVOICES)
        }
      >
        <Card>
          <InputDocumentType
            name={PROVIDED_TO_IC_INVOICES_LIST}
            label={i18n.t('Czego dotyczyły faktury?')}
          />
        </Card>
      </ConditionalRender>
      <ConditionalRender
        when={(val) =>
          val.repair_documents_provided_to_ic
            ?.map((item: Options) => item.value)
            ?.includes(REPAIR_DOCUMENTS_PROVIDED_TO_IC.RECEIPTS)
        }
      >
        <Card>
          <InputDocumentType
            name={PROVIDED_TO_IC_RECEIPTS_LIST}
            label={i18n.t('Czego dotyczyły rachunki?')}
          />
        </Card>
      </ConditionalRender>
      <ConditionalRender
        when={(val) =>
          val.repair_documents_provided_to_ic
            ?.map((item: Options) => item.value)
            ?.includes(REPAIR_DOCUMENTS_PROVIDED_TO_IC.OTHER_DOCUMENTS)
        }
      >
        <Card>
          <InputDocumentType
            name={PROVIDED_TO_IC_OTHER_DOCUMENTS_LIST}
            label={i18n.t('Czego dotyczyły dokumenty?')}
          />
        </Card>
      </ConditionalRender>
      <>
        <Card>
          <CheckboxGroupDamageRightsAssignments />
        </Card>
        <ConditionalRender
          when={(val) =>
            val.damage_rights_assignments
              ?.map((item: Options) => item.value)
              ?.includes(DAMAGE_RIGHTS_ASSIGNMENTS.DAMAGE_AOB)
          }
        >
          <Card>
            <SelectAssignmentOfDamageRightsDocumentsSubject
              name={DAMAGE_AOB_LIST_NAME}
              label={i18n.t('Czego dotyczyła cesja?')}
            />
            <AddDocuments
              name={DOCUMENTS_DAMAGE_AOB_LIST_NAME}
              attachmentTypeId={ATTACHMENT_TYPES.CESJA_INNE}
            />
          </Card>
        </ConditionalRender>
        <ConditionalRender
          when={(val) =>
            val.damage_rights_assignments
              ?.map((item: Options) => item.value)
              ?.includes(DAMAGE_RIGHTS_ASSIGNMENTS.DAMAGE_RIGHTS_AUTHORIZATIONS)
          }
        >
          <Card>
            <SelectAssignmentOfDamageRightsDocumentsSubject
              name={DAMAGE_RIGHTS_AUTHORIZATIONS_LIST_NAME}
              label={i18n.t('Czego dotyczyło upoważnienienie?')}
            />
            <AddDocuments
              name={DOCUMENTS_DAMAGE_RIGHTS_AUTHORIZATIONS_LIST_NAME}
              attachmentTypeId={ATTACHMENT_TYPES.UPOWAZNIENIE_INNE}
            />
          </Card>
        </ConditionalRender>
        <ConditionalRender
          when={(val) =>
            val.damage_rights_assignments
              ?.map((item: Options) => item.value)
              ?.includes(DAMAGE_RIGHTS_ASSIGNMENTS.DAMAGE_RIGHTS_POA)
          }
        >
          <Card>
            <SelectAssignmentOfDamageRightsDocumentsSubject
              name={DAMAGE_RIGHTS_POA_LIST_NAME}
              label={i18n.t('Czego dotyczyło pełnomocnictwo?')}
            />
            <AddDocuments
              name={DOCUMENTS_DAMAGE_RIGHTS_POA_LIST_NAME}
              attachmentTypeId={ATTACHMENT_TYPES.PELNOMOCNICTWO_INNE}
            />
          </Card>
        </ConditionalRender>
      </>
    </>
  );
};

export default SurveyFour;
